<ng-container *transloco="let t">

  <h2 class="text-primary">Envoie un message à {{ hostName() }}</h2>

  @if (isPreview()) {
    <div class="alert alert-warning my-2" role="alert">
      <lucide-icon [img]="icons.preview"></lucide-icon>
      La prise de contact est désactivée pendant la prévisualisation.
    </div>
  }

  @if (messageSent()) {
    <div class="alert alert-success my-2" role="alert">
      <lucide-icon [img]="icons.sent"></lucide-icon>
      Ton message a été envoyé à {{ hostName() }}.
    </div>
  } @else {
    <div class="alert alert-light my-2" role="alert">
      <app-host-contact-privacy-note [host]="host()"></app-host-contact-privacy-note>
    </div>
    @if (form) {
      <form [formGroup]="form" [class.was-validated]="form.touched" (ngSubmit)="sendMessage()">
        <app-email-field
          [formControl]="form.controls.email"
          [label]="'Ton adresse email'"
          [description]="hostName() + ' te répondra à cette adresse.'"
          [maxLength]="255">
        </app-email-field>
        <app-string-field
          [formControl]="form.controls.name"
          [maxLength]="255"
          [label]="'Ton nom et prénom'">
        </app-string-field>
        <app-string-field
          [formControl]="form.controls.phone"
          [maxLength]="255"
          [label]="'Ton numéro de téléphone'"
          [optional]="true">
        </app-string-field>
        <app-string-field
          [formControl]="form.controls.subject"
          [maxLength]="255"
          [label]="'Sujet de ton message'"
          [optional]="true">
        </app-string-field>
        <app-text-field
          [formControl]="form.controls.message"
          [maxLength]="1000"
          [label]="'Ton message'">
        </app-text-field>

        <div class="mt-2">
          <app-altcha [formControl]="form.controls.captcha"/>
        </div>

        <p class="text-end my-2">
          <button type="button" class="btn btn-link" (click)="cancel()">
            Annuler
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="form.invalid || isPreview()">
            <lucide-icon [img]="icons.send"></lucide-icon>
            Envoyer
          </button>
        </p>
      </form>
    }
  }
</ng-container>
